<template>
  <b-dropdown right :text="summaryText" variant="outline-dark" @hide="saveChanges" ref="dropdown" :disabled="disabled">
    <b-dropdown-form style="min-width:320px" v-on:submit.prevent.stop="saveAndClose">
      <b-form-group v-if="users" label="User:">
        <b-form-select v-model="selectedUser" required>
          <option value="null" disabled>Please select an option</option>
          <option v-for="(user, userIndex) in users" :key="userIndex" :value="user">{{user.name}}</option>
        </b-form-select>
      </b-form-group> 
      <b-alert :show="!isValid" variant="danger">{{errorMessage}}</b-alert>
      <p class="text-right mb-0">
        <b-button size="sm" variant="secondary" @click="resetAndClose">Cancel</b-button>
        <b-button size="sm" variant="primary" @click="saveAndClose">Update</b-button>
      </p>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'UserFilter',
  props: ['filter', 'users', 'disabled'],
  data () {
    var user = (this.users != null && this.filter.user_id != null) ? this.users.find((u) => { return parseInt(this.filter.user_id) === u.id }) : null
    return {
      selectedUser: user,
      isValid: true,
      errorMessage: ''
    }
  },
  components: {},
  computed: {
    filterUser () {
      if (this.filter.user_id != null) {
        return this.users.find((u) => { return parseInt(this.filter.user_id) === u.id })
      } else {
        return null
      }
    },
    summaryText () {
      if (this.filter.user_id === null || typeof this.filter.user_id === 'undefined') {
        return 'None'
      } else if (this.filter.user_id) {
        return this.filterUser.name
      }
    }
  },
  watch: {
    selectedCompany () {
      this.selectedTeams = []
    }
  },
  mounted () {
  },
  methods: {
    validate () {
      this.isValid = true
      if (this.users != null) {
        if (this.selectedUser == null) {
          this.isValid = false
          this.errorMessage = 'Please select a user'
          return this.isValid
        }
      }
      return this.isValid
    },
    resetAndClose (evt) {
      this.selectedUser = _.clone(this.filterUser)
      this.isValid = true
      this.errorMessage = ''
      this.$refs.dropdown.hide()
    },
    saveChanges (evt) {
      if (this.validate()) {
        this.commit()
      } else {
        evt.preventDefault()
      }
    },
    saveAndClose () {
      if (this.validate()) {
        this.$refs.dropdown.hide()
      }
    },
    commit () {
      if (this.selectedUser != null) {
        this.filter.user_id = this.selectedUser.id
      } else {
        this.filter.user_id = null
      }
      this.$emit('input', this.filter)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/UserFilter.vue